import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';
import './CustomerLogos.css';

const CustomerLogos = () => {
  const logos = [
    { src: '/img/1.png', alt: 'Natural Athlet Logo', scale: 1.2, opacity: 0.6 },
    { src: '/img/2.png', alt: 'Heilpflanzenwohl Logo', scale: 1.1 },
    { src: '/img/3.png', alt: 'Customer Logo 3', opacity: 0.7 },
    { src: '/img/4.png', alt: 'Ironmax Logo', scale: 1.3 },
    { src: '/img/17.png', alt: 'LILI Liposomal Liquids Logo', scale: 0.75 },
    { src: '/img/5.png', alt: 'Kerbholz Logo', scale: 1.7 },
    { src: '/img/6.png', alt: 'BB Logo', scale: 1.3 },
    { src: '/img/16.png', alt: 'Flavio Simonetti Logo', scale: 1.5 },
    { src: '/img/7.png', alt: 'Customer Logo 7', scale: 1.3 },
    { src: '/img/8.png', alt: 'Customer Logo 8', scale: 1.3 },
    { src: '/img/15.png', alt: 'Keimling Naturkost Logo', scale: 0.85, opacity: 0.7 },
    { src: '/img/9.png', alt: 'Customer Logo 9', scale: 1.3},
    { src: '/img/10.png', alt: 'Customer Logo 10', scale: 1.1 },
    { src: '/img/14.png', alt: 'Clip The Wallet Logo', scale: 0.9, opacity: 1.0 },
    { src: '/img/11.png', alt: 'Customer Logo 11', scale: 1.3 },
    { src: '/img/13.png', alt: 'buxtrade Logo', scale: 1.15 }
  ];

  const gridReveal = useScrollReveal({ threshold: 0.15 });

  return (
    <section className="customer-logos-fox">
      <div className="customer-logos-fox__container">
        <div ref={gridReveal.ref} className={`customer-logos-fox__grid reveal--fade ${gridReveal.isRevealed ? 'reveal--visible' : ''}`}>
          {logos.map((logo, index) => (
            <div key={index} className="customer-logos-fox__item">
              <img 
                src={logo.src} 
                alt={logo.alt}
                className="customer-logos-fox__logo"
                style={{
                  ...(logo.scale && { transform: `scale(${logo.scale})` }),
                  ...(logo.opacity != null && { opacity: logo.opacity }),
                }}
                width={120}
                height={60}
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CustomerLogos;
